import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.disabled)?_c(VTextField,{attrs:{"value":_vm.value ? _vm.value.name : '',"label":_vm.t('orderName'),"disabled":"","required":""}}):_c(VSelect,{attrs:{"value":_vm.value,"label":_vm.t('orderName'),"item-value":"id","item-text":"name","items":_vm.availableOrders,"reverse":"","clearable":"","return-object":"","error-messages":_vm.errorMessages},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }